import objectPath from "object-path";
import React, { useEffect, useRef } from "react";
import { Col } from "react-bootstrap";
import { useIntl } from "react-intl";
import { connect } from "react-redux";

import KTUtil from "@src/_metronic/_assets/js/util";

import useFilters from "@app/hooks/useFilters";
import useQueryParams from "@app/hooks/useQueryParams";

import { CustomersProvider, useCustomersContext } from '@app/pages/customers/context/CustomersContext';
import ROUTES from "@app/router/Routes";

import TriSwitchInput from "@app/partials/content/TriSwitchInput";

import CustomersSearch from "@app/components/forms/search/CustomersSearch";

import KTHeader from "../../_assets/js/header";
import * as builder from "../../ducks/builder";

import HMenu from "./HMenu/HMenu";
import Topbar from "./Topbar";

const HeaderContent = ({ menuHeaderDisplay, headerAttributes, headerClasses }) => {
  const headerCommonRef = useRef();
  const { isDmsActive } = useCustomersContext();
  const params = useQueryParams();
  const Intl = useIntl();

  const { filters, updateFilters } = useFilters({
    name: 'customers_search',
    path: ROUTES.CUSTOMERS.PATH,
    defaultValues: {
      filters: {
        research: { value: params?.research?.trim?.() || null },
        vehicle: { value: params?.vehicle?.trim?.() || null },
        companyName: { value: params?.companyName?.trim?.() || null },
        siret: { value: params?.siret?.trim?.() || null },
        ...(isDmsActive && {
          isDmsPro: { value: params?.isDmsPro === 'true' || false },
        }),
      },
      page: 1,
    },
    persisted: false,
  });

  const searchType = isDmsActive && !params.research && filters?.isDmsPro?.value ? 'company' : 'individual';
  const isCompanyActive = searchType === 'company';

  const setSearchType = (newSearchType) => {
    if (isDmsActive) {
      updateFilters({
        filters: {
          ...filters,
          isDmsPro: { value: newSearchType === 'company' },
        },
      });
    }
  };


  useEffect(() => {
    const options = {};
    if (
      headerCommonRef.current.getAttribute("data-ktheader-minimize") ===
      "1"
    ) {
      options["minimize.desktop.on"] = "kt-header--minimize";
      options["offset.desktop"] = 130;
    }

    // eslint-disable-next-line no-undef, no-new
    new KTHeader(headerCommonRef.current, options);
  }, []);



  const handleSearchTypeChange = (isCompany) => {
    setSearchType(isCompany ? 'company' : 'individual');
  };

  return (
    <div
      className={`kt-header kt-grid__item theme-${searchType} ${headerClasses} `}
      id="kt_header"
      ref={headerCommonRef}
      {...headerAttributes}
    >
      { KTUtil.isDesktopDevice() && (
        <div className="py-2 col-lg-8 ">

          <CustomersSearch
            redirect
            withDmsInputs
            searchType={searchType}
            additionalNode={isDmsActive ? (
              <Col  lg={3} className="gap-2 pl-8 d-flex align-items-center">
                <TriSwitchInput
                  state={isCompanyActive}
                  onChange={handleSearchTypeChange}
                />
                <span
                  className="font-weight-normal switch-label"
                >
                    {Intl.formatMessage({ id: 'CUSTOMERS.TABLE.VIEW.SEARCH.CUSTOMER.PRO' })}
                </span>


              </Col>
            ) : null}
          />

        </div>
      )}

      {/* <!-- begin: Header Menu --> */}
      {menuHeaderDisplay && <HMenu />}
      {/* <!-- end: Header Menu --> */}
      {/* <!-- begin:: Header Topbar --> */}
      {/* <!-- empty div to fix topbar to stay on the right when menu-horizontal is hidden --> */}
      {!menuHeaderDisplay && <div />}
      <Topbar />
      {/* <!-- end:: Header Topbar --> */}
    </div>
  );
};

const mapStateToProps = store => ({
  headerClasses: builder.selectors.getClasses(store, {
    path: "header",
    toString: true
  }),
  headerAttributes: builder.selectors.getAttributes(store, { path: "header" }),
  menuHeaderDisplay: objectPath.get(
    store.builder.layoutConfig,
    "header.menu.self.display"
  ),
  fluid:
    objectPath.get(store.builder.layoutConfig, "header.self.width") === "fluid"
});

const Header = (props) => (
  <CustomersProvider>
    <HeaderContent {...props} />
  </CustomersProvider>
);

export default connect(mapStateToProps)(Header);
